<template>
    <div class="tournament" :class="{'no-thumbnail' : !tournament.posterImgPath}">
        <div>
            
            <div class="tournament-label" :style="{background: getTournamentLabel(tournament).background, color:'#fff',fontSize:'1.2rem',padding: '5px 9px', width: '-webkit-fit-content', width: '-moz-fit-content',width: 'fit-content',lineHeight: '14px', letterSpacing: '-.7px'}" >{{getTournamentLabel(tournament).text}}</div>
            <div class="info-wrap">
                <div>
                    <div class="info-content">

                        <h4 @click="$router.push(`/tournament/${tournament.tnmtId}`)">{{tournament.tnmtName}}</h4>
                        <p class="address">
                            <span v-for="(gym, gymIndex) in tournament.gymList" v-if="gymIndex<2">{{gym.gymName}} </span>
                            <span v-if="tournament.gymList.length > 2">외 {{tournament.gymList.length - 2}}</span>
                        </p>
                        <p class="datetime">
                            <span class="title">접수기간</span>
                            <span class="content">{{changeDateFormat(tournament.enrollStartDate)}} - {{changeDateFormat(tournament.enrolEndDate)}}</span>
                        </p>
                        <p class="datetime">
                            <span class="title">대회기간</span>
                            <span class="content">{{changeDateFormat(tournament.startDate)}} - {{changeDateFormat(tournament.endDate)}}</span>
                        </p>

                        <p class="heart-count" :class="tournament.favoriteCnt === 0 ? 'off' : ''">{{tournament.favoriteCnt}}</p>

                        <div class="detail-btn" v-if="tournament.applyAllowed && tournamentState(tournament) === 1 &&tournament.tnmtType == 1"
                             @click="$router.push(`/tournament/participation/${tournament.tnmtId}`)">참가하기
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <alert-modal :title="'알림'" :content="'오류가 발생했습니다. 잠시 후 시도해주세요'" @close="alertShow =false"
                     v-if="alertShow"></alert-modal>

    </div>

</template>
<script>
    import {mapState} from 'vuex'
    import AlertModal from "../modal/AlertModal";

    export default {
        components: {AlertModal},
        computed: {
            ...mapState('users', ['user'])
        },
        props: ['tournament'],
        data() {
            return {
                alertShow: false
            }
        }
    }
</script>
